var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56712 4.71752e-05C10.1339 -0.00604616 10.6702 0.579447 11.0417 0.997087C11.9142 2.06911 11.4327 3.25709 11.2409 4.55751H15.2203C15.7583 4.56153 16.034 4.96605 15.9966 5.51259L14.8824 12.4167C14.6299 13.2996 13.6485 14.0768 12.6139 14.1872H5.2528C4.81735 14.1815 4.49107 13.8724 4.45692 13.3913V5.35341C4.46257 4.91802 4.77168 4.59167 5.2528 4.55755H7.08281L8.89332 0.499047C8.99401 0.280007 9.25795 0.00499384 9.56712 4.71752e-05ZM2.9052 4.39837C3.21148 4.40227 3.45565 4.61403 3.48133 4.95595V13.8297C3.47689 14.1295 3.22851 14.3629 2.9052 14.3864H0.577147C0.281747 14.3823 0.0278133 14.1584 0 13.8297V4.95597C0.00421333 4.64637 0.23968 4.42183 0.577147 4.39838L2.9052 4.39837Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.07fb229ba8c6bbe8cc8b6f4d0e7a7f38.svg";
export { ForwardRef as ReactComponent };